"use client";

import React from "react";
import { motion } from "framer-motion";
import {
  Users,
  Award,
  Handshake,
  MapPin,
  Briefcase,
  Settings,
  TrendingUp,
} from "lucide-react";
const iconMap = {
  Users,
  Award,
  Handshake,
  MapPin,
  Briefcase,
  Settings,
  TrendingUp,
};

const Countupcards = ({ icon, value, label, delay = 0 }) => {
  const Icon = typeof icon === "string" ? iconMap[icon] : icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      className="group relative overflow-hidden  border border-gray-200/60 bg-white 
                 p-4 sm:p-5 md:p-6 lg:p-7 
                 transition-all duration-500 hover:-translate-y-1 hover:border-orange-200 hover:shadow-2xl hover:shadow-orange-100/30"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50/0 to-amber-50/0 transition-all duration-500 group-hover:from-orange-50/60 group-hover:to-amber-50/40" />

      <div className="relative flex flex-col space-y-3 sm:space-y-4 md:space-y-5">
        <div className="inline-flex w-fit">
          <div
            className="rounded-full bg-gradient-to-br from-[#FC9D00] to-[#FF8800] 
                       p-2.5 sm:p-3 md:p-3.5 lg:p-4 
                       shadow-lg shadow-orange-400/30 
                       transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3"
          >
            {Icon ? (
              <Icon
                className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 lg:h-7 lg:w-7 text-white"
                strokeWidth={2.5}
              />
            ) : null}
          </div>
        </div>

        <div className="space-y-1.5 sm:space-y-2">
          <div
            className="text-sm sm:text-base md:text-lg lg:text-xl 
                       font-bold tracking-tight text-gray-900 
                       transition-colors duration-300 group-hover:text-[#FC9D00]"
            style={{ fontFamily: "saans-bold" }}
          >
            {value}
          </div>
          <p
            className="text-xs sm:text-sm md:text-[15px] lg:text-base leading-relaxed text-gray-600"
            style={{ fontFamily: "saans-regular" }}
          >
            {label}
          </p>
        </div>
      </div>

      <div className="absolute -top-10 -right-10 h-24 w-24 sm:h-28 sm:w-28 md:h-32 md:w-32 rounded-full bg-gradient-to-br from-orange-200 to-amber-200 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-60" />

      <div className="absolute bottom-0 left-0 right-0 h-0.5 sm:h-1 origin-left scale-x-0 rounded-full bg-gradient-to-r from-[#FC9D00] to-[#FF8800] transition-transform duration-500 group-hover:scale-x-100" />
    </motion.div>
  );
};

export default Countupcards;
